/**
 * 对事件对象进行规范化处理，返回事件对象中的值或状态
 * @param e 事件对象
 * @returns 返回事件对象中的值或状态
 */
export function normalizing(e: any) {
  // 如果是数组或者不是对象，直接返回
  if (Array.isArray(e) || typeof e !== 'object') return e;

  // 如果事件对象存在 target 属性
  if (e && e.target) {
    // 如果 target 对象中存在 value 属性，返回 value 属性的值
    if ('value' in e.target) {
      return e.target.value;
    }

    // 如果 target 对象中存在 checked 属性，返回 checked 属性的值
    if ('checked' in e.target) {
      return e.target.checked;
    }
  }

  // 返回事件对象
  return e;
}
